import type { ReactNode } from 'react';
import styles from './split.module.css';

/**
 * Right 40% of the shell — form content + legal footer.
 * The footer sits outside .formInner so it spans the full column width.
 */
export function FormColumn({ children }: { children: ReactNode }) {
  return (
    <main className={styles.formColumn}>
      <div className={styles.formInner}>{children}</div>
      <div className={styles.formFooter}>
        <span>© {new Date().getFullYear()} Velora</span>
        <span className={styles.footerLinks}>
          <a href="https://fatherschool.com/privacy" target="_blank" rel="noreferrer">Privacy</a>
          <a href="https://fatherschool.com/terms" target="_blank" rel="noreferrer">Terms</a>
        </span>
      </div>
    </main>
  );
}
